import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import { ActionBarTitleLoader, useFormattedNumber } from "shared";

import { ContentFrameProps } from "../types";

const ContentFrame = ({ children }: ContentFrameProps) => {
    const { hasNoPermissionToRead, tableName, totalRows, isInitialLoading } =
        useContext(TableContext);

    const { t } = useTranslation();
    const { renderFormattedNumber } = useFormattedNumber();

    return (
        <>
            {isInitialLoading ? (
                <ActionBarTitleLoader
                    customStyle={{
                        "@media(max-width: 599px)": {
                            margin: children ? "0 0 8px 0" : "6px 0"
                        }
                    }}
                />
            ) : (
                <h1
                    css={css({
                        margin: children ? "0" : " 6px 0",

                        "@media(max-width: 599px)": {
                            marginBottom: children ? "8px" : "6px"
                        }
                    })}
                >
                    <span>{t(`General##${tableName}`)}</span>

                    {!hasNoPermissionToRead && (
                        <span>({renderFormattedNumber(totalRows)})</span>
                    )}
                </h1>
            )}

            {children && (
                <div
                    css={css({
                        display: "flex",
                        columnGap: "8px",

                        "@media(max-width: 599px)": {
                            display: "grid",
                            gridAutoFlow: "column",
                            gridAutoColumns: "1fr",
                            gridColumnGap: "16px"
                        }
                    })}
                >
                    {children}
                </div>
            )}
        </>
    );
};

export default ContentFrame;
